import moment from 'moment';

export function convertTimeToMiliSecs(hmsTime) {
  const a = hmsTime.split(':');
  return ((+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2])) * 1000;
}

export function convertMiliSecsToTime(milisecs) {
  return moment.utc(milisecs).format('HH:mm:ss');
}

/**
 * Set a zero before a one digit number if needed by padTime props
 * @param {Number} time - number to analyze
 * @return {String|Number} - the padded number
 * @public
 */
export function pad(time) {
  if (time < 10) {
    return `${time}`;
  }
  return time.toString().padStart(2, '0');
}

export function timerFormatted(hours = null, minutes = null, seconds = null, separator = ' ') {
  const result = [];
  if (hours) {
    result.push(`${pad(hours)}h`);
  }
  if (minutes) {
    result.push(`${pad(minutes)}m`);
  }
  if (seconds) {
    result.push(`${pad(seconds)}s`);
  }
  if (!result.length) {
    return (seconds === 0 ? '0s' : (minutes === 0 ? '0m' : (hours === 0 ? '0h' : '0s'))); // eslint-disable-line no-nested-ternary
  }
  return result.join(separator);
}

export function parseHMSFromSeconds(seconds) {
  const hms = {
    hours: seconds ? Math.floor(seconds / 3600) : 0,
    minutes: seconds ? Math.floor((seconds % 3600) / 60) : 0,
    seconds: seconds ? seconds % 60 : 0,
  };
  return hms;
}
